import React from "react";
import "./Testimonial.css";
import Footer from "../Home/Footer/Footer";
import TestiCards from "./TestiCards/TestiCards";
import pp1 from "./pp1.jpg";
import pp2 from "./pp2.jpg";
import pp3 from "./pp3.jpg";
import pp4 from "./pp4.jpg";
import pp5 from "./pp5.jpg";
export default function Testimonial() {
  return (
    <div id="Testimonial" className="testimonial-container">
      <div className="header-container">
        {" "}
        <h2>
          <span className="primary-text">Testimonial</span>
        </h2>{" "}
        <span style={{ color: "grey" }}>Here from them</span>
        <span> &#8594; &#9827; &#8592;</span>
      </div>
      <div className="testimonial-card-container">
        <div className="testi-card-div">
          <TestiCards
            description={
              "Kokonod is a pretty good programmer in Node.js, demonstrating a good understanding of server-side development. His proficiency in Data Structures and Algorithms (DSA) is commendable."
            }
            name={"Ayush Saha"}
            pic={pp1}
            post={"Professional Freelancer"}
          />
          <TestiCards
            description={
              "Kokonod's problem solving skills and his way of writing clean code is great. His deep knowledge in Backend development is showcased in his projects."
            }
            name={"Dhritiman Roy"}
            pic={pp2}
            post={"SDE TCS Digital"}
          />
          <TestiCards
            description={
              "Kokonod Roy who is my Classmate During Undergraduation has decent coding skills & problem solving ability, also he has good Logical Thinking. I wish him all the best for his career. "
            }
            name={"Debarshi Roy"}
            pic={pp3}
            post={"Ph.d Scholar(Department of EECS) @IISER BHOPAL."}
          />
          <TestiCards
            description={
              "Kokonod is a very hardworking and smart person. He does all the work with a lot of efficiency. He has indulged himself in learning and implementing new technologies."
            }
            name={"Kriti Singh"}
            pic={pp4}
            post={"SWE Intern @IBM ISDL"}
          />
          <TestiCards
            description={
              "Kokonod is a very hardworking person. He is good at his work and does it with passion. "
            }
            name={"Souvik Mondol"}
            pic={pp5}
            post={"SDE DeltaX"}
          />
        </div>
        <Footer className="new-footer" />
      </div>
    </div>
  );
}
